import ModalNewLocation from "../components/ModalNewLocation";
import TableViewLocation from "../components/TableViewLocation";

export default function CommunityScreen() {
  return (
    <section className="flex flex-col gap-4 w-full">
      <TableViewLocation />
      <ModalNewLocation />
    </section>
  );
}
